<app-filter-panel
  [showCategoryFinder]="showCategoryFinder"
  [nameSesion]="nameSesion"
  [filterScroll]="filterScroll"
  [filterView]="filterView"
  [categoriesActive]="offer.categoriesActive"
  [selectedCategoryId]="offer.categorySel?.id ?? ''"
  [showCategoryPlaceholder]="showCategoryPlaceholder"
  [categoryPlaceholderDisabled]="categoryPlaceholderDisabled"
  [isIdSession]="sesion.isIdsession()"
  [subCategories]="offer.subCategories"
  [selectedSubCategoryId]="offer.subCategorySel?.id ?? ''"
  [categoryDescSub]="offer.categorySel?.descSub ?? ''"
  [contOptionChooseCat]="cont_option_choose_cat"
  [contOptionChooseSubcat]="cont_option_choose_subcat"
  [filtersSel]="offer.filtersSel"
  [filtersResetKey]="filtersResetKey"
  [isBackDropFilter]="isBackDropFilter"
  [btnFilterM]="btnFilterM"
  (categorySelected)="selectCategory($event.target, true, true)"
  (subCategorySelected)="selectSubCategory($event.target)"
  (filterValueChange)="handleFilterValueChange($event)"
  (cleanRequested)="cleanAdvancedFil()"
  (viewToggled)="changeFilterView()" />
